import React from 'react';

import { ProfileErrorMessage } from 'pages/Settings/GeoConfigSettings';
import { PostGeoConfigLocation } from 'pages/Settings/GeoConfigSettings/api/useGeoConfig/useGeoConfig';
import Slider from 'pages/Settings/LocalMarketSettings/MarketMap/Slider/Slider';
import Message from '@lotlinx-aws/sparky-component-library/Sparky/Message';
import NumberInput from '@lotlinx-aws/sparky-component-library/Sparky/NumberInput';
import Text from '@lotlinx-aws/sparky-component-library/Sparky/Text';
import TextInput from '@lotlinx-aws/sparky-component-library/Sparky/TextInput';

import styles from './SetPinDetail.module.scss';

export interface SetPinDetailProps {
  editingPin?: PostGeoConfigLocation;
  onLongChange(e: React.ChangeEvent<HTMLInputElement>): void;
  onLatChange(e: React.ChangeEvent<HTMLInputElement>): void;
  onRadiusChange(value: number[]): void;
  errorMessage: ProfileErrorMessage;
}

/**
 * SetPinDetail
 */
export default function SetPinDetail({
  editingPin,
  onLongChange,
  onRadiusChange,
  onLatChange,
  errorMessage,
}: SetPinDetailProps) {
  return (
    <div className={styles.setPinDetail}>
      <div className={styles.latLngContainer}>
        <Text color='secondary' size='16' fontWeight={5}>
          Longitude
        </Text>
        <NumberInput
          id='longitude'
          size={'sm' as any}
          value={editingPin?.longitude}
          onChange={(e) => onLongChange(e)}
          className={styles.latLngInput}
        />
      </div>
      <div className={styles.latLngContainer}>
        <Text color='secondary' size='16' fontWeight={5}>
          Latitude
        </Text>
        <NumberInput
          id='latitude'
          size={'sm' as any}
          value={editingPin?.latitude}
          onChange={(e) => onLatChange(e)}
          className={styles.latLngInput}
        />
      </div>
      <div className={styles.radiusContainer}>
        <Text color='secondary' size='16' fontWeight={5}>
          Radius
        </Text>
        <Text size='14'>15 mi</Text>
        <Slider
          value={[editingPin?.radius ?? 15]}
          setValue={onRadiusChange}
          defaultValue={[15]}
          min={15}
          max={500}
        />
        <Text size='14'>500 mi</Text>
        <TextInput
          id='radius'
          type='number'
          size='sm'
          max={500}
          min={15}
          value={editingPin?.radius ?? 30}
          onChange={(e) => onRadiusChange([Number(e.target.value)])}
          className={styles.radiusInput}
        />
      </div>
      {(errorMessage.pinLatitude || errorMessage.pinLongitude || errorMessage.pinRadius) && (
        <Message
          category='danger'
          heading='Incorrect pin information'
          dismissable={false}
          children={
            <div className={styles.pointList}>
              {errorMessage.pinLongitude && (
                <Text className={styles.point}>
                  <span className={styles.bullet} />
                  {errorMessage.pinLongitude}
                </Text>
              )}
              {errorMessage.pinLatitude && (
                <Text className={styles.point}>
                  <span className={styles.bullet} />
                  {errorMessage.pinLatitude}
                </Text>
              )}
              {errorMessage.pinRadius && (
                <Text className={styles.point}>
                  <span className={styles.bullet} />
                  {errorMessage.pinRadius}
                </Text>
              )}
            </div>
          }
        />
      )}
    </div>
  );
}
